import React, { useState, useRef } from 'react';
import AuthorProfileCard from './AuthorProfileCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
SwiperCore.use([Navigation]);

import styled from 'styled-components';
import {
  LeftSwipperArrows,
  RightSwipperArrows
} from '../../../../shared-components/SwipperArrows/SwipperArrows';
import { Author } from '../../../../pages/blog';

interface BlogAuthorProps {
  authors: Author[];
}

const StyledSwipper = styled(Swiper)`
  margin: 0px !important;
  .swiper-slide {
    width: 350px;
    justify-content: center;
    display: flex;
  }
`;

export default function BlogAuthors({ authors }: BlogAuthorProps) {
  const [isLastSlide, setIsLastSlide] = useState(false);
  const [isFirstSlide, setIsFirstSlide] = useState(false);

  const prevRef = useRef<HTMLDivElement>(null);
  const nextRef = useRef<HTMLDivElement>(null);

  const handleSlideChange = (swiper: any) => {
    setIsLastSlide(swiper.isEnd);
    setIsFirstSlide(swiper.isBeginning);
  };

  const handleSwiperInit = (swiper: any) => {
    swiper.params.navigation.prevEl = prevRef.current;
    swiper.params.navigation.nextEl = nextRef.current;
    swiper.navigation.init();
    swiper.navigation.update();

    setIsFirstSlide(swiper.isBeginning);
    setIsLastSlide(swiper.isEnd);
  };

  return (
    <div className="flex flex-col gap-[22px] sm:gap-[40px] xl:gap-[60px]">
      <div className="flex items-center justify-between">
        <h2 className="text-black2 text-xl sm:text-[22px] md:text-[26px] lg:text-[26px] 2xl:text-3xl 3xl:text-4xl font-semibold">
          Our Authors
        </h2>
        <div className="flex">
          <div className="flex gap-2">
            <div ref={prevRef} className="prev">
              <LeftSwipperArrows isFirstSlide={isFirstSlide} />
            </div>
            <div ref={nextRef} className="next">
              <RightSwipperArrows isLastSlide={isLastSlide} />
            </div>
          </div>
        </div>
      </div>

      <StyledSwipper
        slidesPerView={5}
        spaceBetween={10}
        grabCursor
        onSlideChange={handleSlideChange}
        onInit={handleSwiperInit}
        navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
        breakpoints={{
          320: { slidesPerView: 2 },
          425: { slidesPerView: 3 },
          640: { slidesPerView: 3 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 5 },
          1280: { slidesPerView: 6 },
          1440: { slidesPerView: 6 },
          1800: { slidesPerView: 7 },
          1920: { slidesPerView: 8 },
          2200: { slidesPerView: 9 }
        }}
      >
        {authors?.map((author, index) => (
          <SwiperSlide key={index}>
            <AuthorProfileCard author={author} />
          </SwiperSlide>
        ))}
      </StyledSwipper>
    </div>
  );
}
